import { render, staticRenderFns } from "./Audience.vue?vue&type=template&id=0d4164b3&scoped=true"
import script from "./Audience.vue?vue&type=script&lang=js"
export * from "./Audience.vue?vue&type=script&lang=js"
import style0 from "./Audience.vue?vue&type=style&index=0&id=0d4164b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4164b3",
  null
  
)

export default component.exports